function parseMaybeJson(value) {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  if (!trimmed || (trimmed[0] !== "{" && trimmed[0] !== "[")) return value;

  try {
    return JSON.parse(trimmed);
  } catch (e) {
    return value;
  }
}

function normalizeCrumbItem(item) {
  const parsed = parseMaybeJson(item);
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return null;
  if (!parsed.name) return null;

  return {
    name: String(parsed.name),
    path: parsed.path || "",
    query: typeof parsed.query === "undefined" ? "" : parseMaybeJson(parsed.query),
  };
}

function normalizeCrumbs(crumbs) {
  const parsed = parseMaybeJson(crumbs);
  const list = Array.isArray(parsed) ? parsed : [parsed];
  const normalized = [];

  list.forEach((item) => {
    const itemParsed = parseMaybeJson(item);
    if (Array.isArray(itemParsed)) {
      normalized.push(...normalizeCrumbs(itemParsed));
      return;
    }

    const crumb = normalizeCrumbItem(itemParsed);
    if (crumb) normalized.push(crumb);
  });

  return normalized;
}

function readRouteText(routeText) {
  const parsed = parseMaybeJson(routeText);
  return Array.isArray(parsed) ? parsed : [];
}

function getRouteCrumbs(routeText, currentPath) {
  const routes = readRouteText(routeText);
  let matched = null;

  function walk(items, stack) {
    for (let i = 0; i < items.length; i += 1) {
      const item = items[i];
      const nextStack = stack.concat(item);
      if (item.path === currentPath) {
        matched = nextStack;
        return true;
      }
      if (item.children && walk(item.children, nextStack)) return true;
    }
    return false;
  }

  walk(routes, []);
  if (!matched) return [];

  const visibleStack = matched.length > 1 ? matched.slice(1) : matched;
  return visibleStack
    .filter((item) => item && item.meta && item.meta.title)
    .map((item, index) => ({
      name: item.meta.title,
      path: index === visibleStack.length - 1 ? "" : item.path || "",
      query: "",
    }));
}

function resolveCrumbs(crumbs, routeText, currentPath) {
  const normalized = normalizeCrumbs(crumbs);
  if (normalized.length > 0) return normalized;
  return getRouteCrumbs(routeText, currentPath);
}

module.exports = {
  getRouteCrumbs,
  normalizeCrumbs,
  resolveCrumbs,
};
